"use client";

import { motion } from "framer-motion";

export const QuestsHeroSection = () => {
  return (
    <div className="relative w-full overflow-hidden rounded-3xl bg-[#0C1113] border border-gray-800/50">
      {/* Desktop Hero */}
      <div className="hidden md:block relative w-full h-[300px]">
        <img
          src="https://pulsarmoney.b-cdn.net/rhuna/quest_background.png"
          alt="Quest Hero"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/60 to-black/80 flex flex-col items-center justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <p className="text-sm text-gray-300 mb-2 font-medium">Earn with</p>
            <h1 className="text-5xl font-bold text-white mb-3 drop-shadow-lg">Quests</h1>
            <p className="text-lg text-gray-200 max-w-md font-medium">
              Complete challenges, accumulate points and get rewarded.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Mobile Hero */}
      <div className="block md:hidden relative w-full h-[350px]">
        <img
          src="https://pulsarmoney.b-cdn.net/rhuna/quest_background.png"
          alt="Quest Hero"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/60 to-black/80 flex flex-col items-center justify-center px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <p className="text-sm text-gray-300 mb-2 font-medium">Earn with</p>
            <h1 className="text-4xl font-bold text-white mb-3 drop-shadow-lg">Quests</h1>
            <p className="text-base text-gray-200 font-medium">
              Complete challenges, accumulate points and get rewarded.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};
